import { toBoolean } from "../../helpers/string";
import DataStore from "./data-store";

const dataStore = new DataStore("StorageService", { 
  enableCaching: true, 
  enableCacheCompression: toBoolean(process.env.COMPRESS_LOCAL_STORAGE_DATA),
  cache: localStorage, 
});

export default class StorageService {
  static setItem(key: string, data) {
    return dataStore.set(key, data); // return localStorage.setItem(key, JSON.stringify(data));
  }

  static getItem(key: string) {
    return dataStore.get(key);

    /*const item = localStorage.getItem(key);

    try {
      if(item) { 
        return JSON.parse(item);
      }
    } catch {
      return item;
    }*/
  }

  static removeItem(key: string) {
    return dataStore.delete(key); // return localStorage.removeItem(key);
  }
}
